type itemPositionT = {
  top: number;
  left: number;
  height: number;
  width: number;
};

export const getPosition = ({ height, width, top, left }: itemPositionT) => {
  const windowCenter = window.innerWidth / 2;

  const popupTopPosition = top - height * (10 / 11);

  if (left < windowCenter) {
    return {
      top: popupTopPosition,
      left,
      transform: `translate(0)`,
    };
  }

  const popupLeftPosition = left - width / 2;
  return {
    top: popupTopPosition,
    left: popupLeftPosition,
  };
};
